var map = {
	"./cow_name_plate.png": 5462,
	"./menuBtn.png": 2645,
	"./nav_btn_background.png": 8318,
	"./profile.png": 8510,
	"./section1_background.png": 9944,
	"./section2_1.png": 3881,
	"./section3_t1_en.png": 9781,
	"./section3_t1_zh.png": 3770
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4244;